import { TableCell, TableRow } from "@loot-os/ui/components/table";
import type { ReactNode } from "react";

/** A table body's one-line message: loading, empty, or the query's own error. */
export function TableMessageRow({
  colSpan,
  children,
  tone = "muted",
}: {
  colSpan: number;
  children: ReactNode;
  tone?: "muted" | "error";
}) {
  return (
    <TableRow>
      <TableCell
        colSpan={colSpan}
        className={`py-6 text-center ${tone === "error" ? "text-destructive" : "text-muted-foreground"}`}
      >
        {children}
      </TableCell>
    </TableRow>
  );
}
